module.exports = __webpack_public_path__ + "img/partner.5a338a9c.svg";